import type { Courier } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleCourierQueryResult {
  courier: Courier
}

export interface SingleCourierQueryVariables {
  id?: GQL_ID
}

const GQL_QUERY_SINGLE_COURIER = gql`
  query (
    $id: ID!
  ) {
    courier: singleCourier(
      id: $id
    ) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      shops {
        id
        name
        address
      }
      deliveryZones {
        id
        name
      }
      is_shift_require_confirmation
    }
  }
`

export const useFetchSingleCourier = (variables: SingleCourierQueryVariables) =>
  useQuery<SingleCourierQueryResult, SingleCourierQueryVariables>(
    GQL_QUERY_SINGLE_COURIER,
    { variables, skip: !variables.id }
  )
